import type * as React from 'react';
import { CheckboxButton } from '@cian/ui-kit';
import { IPaginationItem } from '../../types/layouts/layoutsCatalog';

interface IPaginationButtonProps extends IPaginationItem {
  onClick(page: number): void;
}

export function PaginationButton({ onClick, value, disabled, label }: IPaginationButtonProps): React.JSX.Element {
  const onClickHandler = () => {
    onClick(value);
  };

  return <CheckboxButton disabled={disabled} onChange={onClickHandler} label={label} checked={false} size="M" />;
}
